import { EventEmitter } from "eventemitter3";
import UploadBlockService from "./uploadBlockService";

export default class UploadFileService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
    this.uploader = null;
  }

  async execute(tid, fid, uploadId, fileId, file, blocks, blockSize, token) { 
    for (const block of blocks) {
      const { seq, size } = block;
      const start = (seq - 1) * blockSize;
      const end = start + size;
      const stream = file.slice(start, end);
      const { cancel } = await this._upload(
        tid,
        fid,
        fileId,
        uploadId,
        stream,
        block,
        token
      );
      if (cancel) return this.emit("abort");
    }
    this.emit("complete");
  }

  _upload(tid, fid, fileId, uploadId, stream, block, token) {
    return new Promise((resolve, reject) => {
      const { url, headers } = this;
      this.uploader = new UploadBlockService(url, headers);
      this.uploader.on("uploadBytes", (bytes) => {
        this.emit("uploadBytes", { tid, fid, bytes });
      });
      this.uploader.on("complete", () => {
        resolve({ cancel: false });
      });
      this.uploader.on("abort", () => {
        resolve({ cancel: true });
      });
      this.uploader.on("error", (err) => reject(err));
      this.uploader.execute(fileId, uploadId, stream, block, token);
    });
  }
}
